import { forwardRef } from 'react';
import { LONG_PRESS_CLASS, useLongPress } from '@/components/mobile';
import { cn } from '@/lib/utils';

/**
 * A long-pressable block for class components (ChatBubble can't call hooks).
 * Touch only: the mouse keeps its own menus. The press shrinks the block a
 * little, the way an iOS context menu lifts a message.
 */
const LongPressArea = forwardRef(({ onLongPress, disabled = false, className, children, ...props }, ref) => {
  const handlers = useLongPress(() => onLongPress?.(), { disabled });
  return (
    <div
      ref={ref}
      {...props}
      {...handlers}
      className={cn(
        !disabled && LONG_PRESS_CLASS,
        'transition-transform duration-150 active:scale-[0.98] motion-reduce:transition-none motion-reduce:active:scale-100',
        className,
      )}
    >
      {children}
    </div>
  );
});
LongPressArea.displayName = 'LongPressArea';

export default LongPressArea;
